import styles from "../UserFields.module.scss";
import { CompanyData, ValidCompanyDataErrors } from "../../../../types/user";
import { Input } from "../../../simples/Input";
import { TextWithHintIcon } from "../../../simples/TextWithHintIcon";

type Props = {
  data: CompanyData;
  setData: (field: keyof CompanyData, value: string) => void;
  errors: ValidCompanyDataErrors | undefined;
  isBeenChange?: boolean;
};

const RightPartIndividualUserFields = ({ data, setData, errors }: Props) => (
  <div className={styles.topSiteContainer}>
    <TextWithHintIcon
      classes={{ root: styles.topTitle }}
      title={"Фамилия"}
    />
    <Input
      ml={25}
      error={errors?.surname && errors.surname[0]}
      classes={{ input: styles.input }}
      onChange={setData.bind(null, "surname")}
      value={data.surname}
      placeholder="Введите фамилию"
    />

    <TextWithHintIcon
      classes={{ root: styles.title }}
      title="Имя"
    />
    <Input
      ml={25}
      error={errors?.["first-name"] && errors["first-name"][0]}
      classes={{ input: styles.input }}
      onChange={setData.bind(null, "first-name")}
      value={data["first-name"]}
      placeholder="Введите имя"
    />

    <TextWithHintIcon
      classes={{ root: styles.title }}
      title="Отчество"
    />
    <Input
      ml={25}
      error={errors?.patronymic && errors.patronymic[0]}
      classes={{ input: styles.input }}
      onChange={setData.bind(null, "patronymic")}
      value={data.patronymic}
      placeholder="Введите отчество"
    />
    <TextWithHintIcon classes={{ root: styles.title }} title="ОГРНИП" />
    <Input
      ml={15}
      error={errors?.["ogrn"] && errors["ogrn"][0]}
      classes={{ input: styles.input }}
      onChange={setData.bind(null, "ogrn")}
      value={data["ogrn"]}
      placeholder="Введите номер"
    />
    <TextWithHintIcon classes={{ root: styles.title }} title="ОКВЭД" />
    <Input
      ml={9}
      error={errors?.["okveds"] && errors["okveds"][0]}
      classes={{ input: styles.input }}
      onChange={setData.bind(null, "okveds")}
      value={data["okveds"]}
      placeholder="Введите значение"
    />
  </div>
);

export default RightPartIndividualUserFields;
